
































































































import { DatasetAnalysisRule } from '@/interfaces/types/Dataset';
import Vue, { PropType } from 'vue';
import CheckBox from '../common/CheckBox/CheckBox.vue';

import Input from '../common/Input/Input.vue';
import Select from '../common/Select/CustomSelect.vue';
import HintButton from '../common/Button/HintButton.vue';

export default Vue.extend({
  components: {
    Input,
    CheckBox,
    Select,
    HintButton,
  },
  props: {
    requiredWidth: {
      type: Number,
    },
    requiredHeight: {
      type: Number,
    },
    requiredSize: {
      type: Number,
    },
    requiredSimilarity: {
      type: Number,
    },
    analysisRule: {
      type: Object as PropType<DatasetAnalysisRule>,
    },
    isOptionInvalid: {
      type: Boolean,
    },
  },
  data(): {
    width: number;
    height: number;
    size: number;
    similarityEnabled: boolean;
    similarity?: number;
    cropEnabled: boolean;
    per: 'folder' | 'label';
    rootPath: string;
    imagePath: string;
    labelPath: string;
    labelType: string;
    cropPath: string;
    labelTypeMapper: { [key: string]: 'coco' | undefined };
    labelTypeMenuList: string[];
    rootPathHint: string;
    labelPathHint: string;
  } {
    // TBD select value - option mapper 패턴화, 코드 분리 (DatasetCreateView에도 같은 코드 사용됨)
    const labelTypeMapper: { [key: string]: 'coco' | undefined } = {
      'COCO Dataset': 'coco',
    };

    return {
      width: this.requiredWidth,
      height: this.requiredHeight,
      size: this.requiredSize,
      similarityEnabled: false,
      similarity: this.requiredSimilarity,
      cropEnabled: false,
      labelType: 'COCO Dataset',
      per: 'folder',
      rootPath: '',
      imagePath: '',
      labelPath: '',
      cropPath: '',
      labelTypeMenuList: Object.keys(labelTypeMapper),
      labelTypeMapper: labelTypeMapper,
      rootPathHint: `유사도를 분석할 이미지들이 폴더별로 구분되어있는 최상위 폴더를 입력해주세요.
        <br/><br/>ex 1.<br/>
        이미지 전체 경로 : C:\\dataset\\images\\:folderId?\\keyframes
        <br/>
        유사도 측정 경로 : C:\\dataset\\images
        <br/>
        이미지 폴더 이름 : keyframes
        <br/>
        <br/>ex 2.<br/>
        폴더 식별자를 사용한 가변 경로가 필요할 경우
        <br/>
        이미지 전체 경로 : C:\\img\\:folderId?\\:folderId?\\crop
        <br/>
        유사도 측정 경로 : C:\\img
        <br/>
        이미지 폴더 이름 : :folderId?\\imgs
        `,
      labelPathHint: `폴더별로 이미지를 크롭하기 위한 라벨 파일이 저장된 폴더를 입력해주세요.        <br/><br/>ex.<br/>
        이미지 전체 경로 : C:\\dataset\\images\\:folderId?\\keyframes
        <br/>
        라벨 전체 경로 : C:\\dataset\\images\\:folderId?\\annotations
        <br/>
        라벨링 폴더 이름 : annotations`,
    };
  },
  mounted() {
    this.$emit('update:isOptionInvalid', this.computedInvalid);
  },
  computed: {
    localAnalysisRule(): DatasetAnalysisRule {
      return {
        similarityAnalysis: {
          per: this.per,
          imagePath: this.imagePath,
          rootPath: this.rootPath,
          labelPath: this.labelPath,
          labelType: this.labelTypeMapper[this.labelType],
          cropPath: this.cropPath,
        },
      };
    },
    computedInvalid(): boolean {
      const isInvalid =
        /** 유사도 측정 옵션이 켜진 상태에서, */
        this.similarityEnabled &&
        /** 유사도에 제대로된 입력이 들어왔는가? */
        (!this.similarity ||
          isNaN(+this.similarity) ||
          +this.similarity < 0 ||
          this.localAnalysisRuleInvalid);
      return isInvalid;
    },
    localAnalysisRuleInvalid(): boolean {
      return (
        /** rootPath가 입력되었는가? */
        !this.rootPath ||
        /** imagePath가 입력되었는가? */
        !this.imagePath ||
        /** 크롭 진행 옵션이 켜진 상태에서, */
        (this.cropEnabled &&
          /** labelType이 선택되었는가? */
          (!this.labelType ||
            /** labelPath가 입력되었는가? */
            !this.labelPath))
      );
    },
  },
  watch: {
    /** TBD 추후 여러 label type 대응 구현 필요, 현재 필요에 따라 COCO만 대응 */
    // labelType: {
    //   handler(value: string) {},
    // },
    similarityEnabled: {
      handler(value: boolean) {
        if (value) {
          this.localAnalysisRule.similarityAnalysis = {
            per: 'folder',
            labelType: 'coco',
            rootPath: '',
            imagePath: '',
          };
        } else {
          this.localAnalysisRule.similarityAnalysis = undefined;
        }
        this.similarity = undefined;
      },
    },
    cropEnabled: {
      handler(value: boolean) {
        if (this.localAnalysisRule.similarityAnalysis)
          this.per = value ? 'label' : 'folder';
      },
    },
    localAnalysisRule: {
      handler() {
        this.$emit('update:analysisRule', this.localAnalysisRule);
      },
      deep: true,
    },
    computedInvalid: {
      handler(invalid: boolean) {
        this.$emit('update:isOptionInvalid', invalid);
      },
    },
  },
  methods: {
    updateWidth() {
      this.$emit('update:requiredWidth', this.width ? +this.width : undefined);
    },
    updateHeight() {
      this.$emit(
        'update:requiredHeight',
        this.height ? +this.height : undefined,
      );
    },
    updateSize() {
      this.$emit('update:requiredSize', this.size ? +this.size : undefined);
    },
    updateSimilarity() {
      this.$emit(
        'update:requiredSimilarity',
        this.similarity ? +this.similarity : undefined,
      );
    },
  },
});
